import { ThreadExportEvent } from '@/api/hooks/useThreadExportEvents';
import { APIBaseChronos } from '@/api/hosts';
import { GenericExportProgressModal } from '@/components/molecules/GenericExportProgressModal';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  caseId: string;
  threadId: string;
  messageId: string;
  onDownload: () => Promise<void>;
  isCreating: boolean;
  error?: string;
}

/**
 * Progress modal for thread (Kim Answer) exports with source documents.
 * Thin wrapper around GenericExportProgressModal with thread-specific configuration.
 */
export const ThreadExportProgressModal = ({
  isOpen,
  onClose,
  caseId,
  threadId,
  messageId,
  onDownload,
  isCreating,
  error,
}: Props) => {
  return (
    <GenericExportProgressModal<ThreadExportEvent>
      isOpen={isOpen}
      onClose={onClose}
      exportConfig={{
        progressEndpoint: `${APIBaseChronos}/api/case/${caseId}/thread/${threadId}/message/${messageId}/export-progress`,
      }}
      itemName="Kim Answer"
      onDownload={onDownload}
      isCreating={isCreating}
      error={error}
    />
  );
};
